import { Injectable } from '@angular/core';
import { ApiService, } from './api.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { Subscription } from '../models/index';

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class SubscriptionService extends ApiService<Subscription> {

	protected apiName: string = 'subscription';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	updateSubscription(subscriptionId: number): Observable<updateSubResponse> {
		return this.http.post<updateSubResponse>(
			this.getBaseUrl('update_subscription'),
			{
				subscription_id: subscriptionId
			}
		);
	}

}

interface updateSubResponse {
	success: boolean;
	error: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/subscription.service.ts